import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "b154c2b4-d8d2-4381-a6b9-ed44fd419924",
    content: "Formulating a quantitative link between a<br>measurable physical stimulus and hearing<br>sensations. ",
    options: {},
  },
  {
    id: "5beaba00-2df0-4ef6-9e08-ceba72c4841d",
    content: "Rendering the non linear behaviour of auditory<br>perception into linear values.",
    options: {},
  },
  {
    id: "7d7156db-e020-46ab-870e-69cc11f6272e",
    content: "Aiding in identification and suppression of<br>annoying noise elements.",
    options: {},
  },
  {
    id: "f5d6048b-1b00-4a1a-842d-d3304d59456a",
    content: "The cognitive effect of noise.",
    options: {},
  },
  {
    id: "710ec2b1-a8ad-40b8-9b70-e35c230ea78a",
    content: "Rendering the behaviour of auditory<br>perception into a logarithmic scale.",
    options: {},
  },
  {
    id: "a99d36b3-2cfd-4249-a7d6-9c530054924fh",
    content: "Formulating a subjective link between a<br>measurable physical stimulus and hearing<br>sensations.",
    options: {},
  },
];

export const task: Task = {
  id: "86f61012-fb81-4285-b0f8-7eb39ec4b48c",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "b154c2b4-d8d2-4381-a6b9-ed44fd419924",
    "5beaba00-2df0-4ef6-9e08-ceba72c4841d",
    "7d7156db-e020-46ab-870e-69cc11f6272e",
    "f5d6048b-1b00-4a1a-842d-d3304d59456a",
  ],
};
